/*
 * @Author: shuaiweige shuaiweitxd1@163.com
 * @Date: 2022-05-06 15:30:09
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-09-13 14:10:57
 * @FilePath: \cem-portal-frontend\src\layout\CustomLayout.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineComponent,
  reactive,
  ref,
  onErrorCaptured,
  watch,
  getCurrentInstance,
  onMounted,
  computed
} from '@vue/composition-api'
import {
  useDispatch,
  useHistory,
  useRequest,
  useSelector,
  useAsyncDispatch
} from '@/utils/bhooks'
import './CustomLayout.scss'
import circleUrl from '@/assets/images/user.png'
import { userLogout, userLogin } from '@/services/auth'
import { getParamsValue, tran } from '@/utils/assist'
import BreadCrumb from '@/components/BreadCrumb/index.vue'
import _ from 'lodash'
import TagsView from './TagView'
import DeleteTips from '@/components/DeleteTips'
import i18n from '@/locales'
import { getStorage, setStorage } from '../utils/assist'
import { languageStyleMap } from './style'
import AnnouncementMarguee from '@/components/announcementMarguee'
import { getUrlSetup } from '@/services/setting/systemFeedback'
import { funcUrlDel } from '@/utils/utils'
import {
  getUserInfo,
  getIsManage
} from '@/services/personalCenter/personalInfo'
import noData from '@/assets/images/noData.png'
import sensors from '@/utils/sensors'
const Layout = defineComponent({
  setup(props, context) {
    //添加全局错误提示
    const { errorTips } = useSelector(({ errorTips }) => ({ errorTips }))
    const { safety } = useSelector(({ safety }) => ({ safety }))
    const instance = getCurrentInstance()
    const theseRoutesDoNotNeedBackground = [
      '/personalCenter/personalInfo',
      '/monitorOverview/researchDetail',
      '/dataAnalysis/surveyData/detail/',
      '/content/templateDetail',
      // '/dataAnalysis/pushAndRecovery',
      '/dataAnalysis/userData',
      '/dataAnalysis/userData/detail',
      '/dataAnalysis/surveyData',
      '/preWarning/preWarningData'
    ] // 在这里添加不需要layout背景的路由
    const noNeedFootList = ['/content/templateDetail'] // 在这里添加不需要footer的路由
    const needPortalRoute = [
      '/monitorOverview/researchDetail',
      '/monitorOverview/editResearch',
      '/monitorOverview/shareLink',
      '/content/templateDetail',
      '/preWarning/preWarningRuleEdit',
      '/monitorOverview/createResearch',
      '/dataAnalysis/subscribeEdit',
      '/setting/systemFeedback'
    ] // 在这里添加需要底部通栏按钮的路由
    const { state: userLogoutState, run: userLogoutRun } =
      useRequest(userLogout)
    const { state: userLoginState, run: userLogintRun } = useRequest(userLogin)
    const { state: userInfoData, run: getUserInfoFn } = useRequest(getUserInfo)
    const { state: isManage2, run: getIsManageFn } = useRequest(getIsManage)
    const commit = useDispatch()
    const dispatch = useAsyncDispatch()
    const { app } = useSelector(({ app }) => ({ app }))
    let isCollapse = ref(false)
    let menuData = reactive([])
    let sideMenuData = reactive([])
    let router = useHistory()
    let routes = router?.options?.routes ?? []
    let rootPath = router?.history?.current?.meta?.rootPath
    let showBgColor = ref(true)
    let showFooter = ref(true)
    let showBuutonPack = ref(false)
    let language = ref(getStorage('lang') === 'en' ? 'english' : 'chinese')
    let languageBool = ref(true)
    let needDisabled = ref(false)
    onErrorCaptured(() => {})
    watch(() => app.permissionsControl, getMenuData, { deep: true })
    function getMenuData() {
      instance?.proxy.$forceUpdate()
      menuData = []
      routes
        .filter((item: any) => {
          return !item?.hidden
        })
        .forEach((item: any) => {
          if (!!item.redirect && item?.children.length) {
            item.children.forEach((element) => {
              if (element.path === '/setting') {
                element.children.forEach((sonEle) => {
                  if (
                    [
                      '/setting/roleManagement',
                      '/setting/accountManagement',
                      '/setting/announcementManagement',
                      '/setting/systemFeedback'
                    ].includes(sonEle.path)
                  ) {
                    let lastPath = sonEle.path.split('/')[2]
                    if (app.permissionsControl[lastPath]?.get) {
                      sonEle.hidden = false
                    } else {
                      sonEle.hidden = true
                    }
                  }
                  if (
                    [
                      '/setting/userEvent',
                      '/setting/handoverManagement'
                    ].includes(sonEle.path)
                  ) {
                    const isEventAdmin =
                      sessionStorage.getItem('isEventAdmin') == '1'
                    sonEle.hidden = !isEventAdmin
                  }
                })
              }
            })
            menuData.push(...item.children)
          } else {
            menuData.push(item)
          }
        })
      getSideMenuData(rootPath, false)
    }

    function getSideMenuData(
      rootPath,
      needRedirect /**手动切换才需要重置到第一个menu */
    ) {
      sideMenuData = []
      menuData.forEach((menu: any) => {
        if (menu.path == rootPath) {
          let sideData = _.cloneDeep(
            menu?.children ? [...menu.children] : [menu]
          )
          //当hidden为true时，去掉children
          sideMenuData = sideData.map((v) => {
            if (v.subHidden) {
              delete v.children
            }
            return v
          })
        }
      })
      needRedirect &&
        commit('app/setActiveSiderMenuIndex', sideMenuData[0].path)
    }

    function handleNavSelect(key, keyPath) {
      if (
        key === '/design' &&
        ['/design/journeyMap'].includes(router?.history?.current?.path)
      ) {
        window.location.replace('/v2/front/design/journeyMap')
      }
      commit('app/setActiveMenuIndex', key)
      getSideMenuData(key, true)
    }

    function handleSideMenuSelect(key, keyPath) {
      if (
        key === app.activeSiderMenuIndex &&
        ['/design/journeyMap', '/design/bluePrint'].includes(key)
      ) {
        window.location.reload()
      }
    }

    const afterRouteChange = () => {
      const {
        meta: { rootPath, leftMenuPath }
      } = instance?.proxy.$router.currentRoute
      commit('app/setActiveMenuIndex', rootPath)
      commit('app/setActiveSiderMenuIndex', leftMenuPath)
    }

    router?.beforeEach((to, from, next) => {
      showBgColor.value = !theseRoutesDoNotNeedBackground.find((item) => {
        return to.path.includes(item)
      })
      showFooter.value = !noNeedFootList.includes(to?.fullPath)
      showBuutonPack.value = needPortalRoute.includes(to.path)
      const {
        meta: { rootPath, leftMenuPath }
      } = to
      commit('app/setActiveMenuIndex', rootPath)
      commit('app/setActiveSiderMenuIndex', leftMenuPath)
      next()
    })

    //refresh
    showBgColor.value = !theseRoutesDoNotNeedBackground.find((item) => {
      return (router?.history?.current?.path || '').includes(item)
    })
    showFooter.value = !noNeedFootList.includes(router?.history?.current?.path)
    showBuutonPack.value = needPortalRoute.includes(
      router?.history?.current?.path
    )
    const persional = reactive({
      userName: 'gcommon-admin',
      userAccount: 'admin'
    }) // 个人信息 工号姓名 头像

    function handlerToggleSideBar() {
      isCollapse.value = !isCollapse.value
    }
    function generateMenuItem(menuItem) {
      if (!menuItem.hidden || menuItem.isTop) {
        return (
          <el-menu-item
            index={menuItem.path}
            key={menuItem.path + menuItem.meta.title}>
            <i class={menuItem.meta?.icon}></i>
            <el-tooltip
              content={tran(`menu.${menuItem.meta.title}`)}
              placement="top-start"
              disabled={needDisabled.value}>
              <span
                ref={menuItem.path}
                onMouseenter={(event) => {
                  needDisabled.value =
                    context.refs?.[menuItem.path]?.scrollWidth <=
                    Math.round(
                      context.refs?.[menuItem.path]?.getBoundingClientRect()
                        .width
                    )
                }}
                onMouseleave={(event) =>
                  (needDisabled.value =
                    context.refs?.[menuItem.path]?.scrollWidth <=
                    Math.round(
                      context.refs?.[menuItem.path]?.getBoundingClientRect()
                        .width
                    ))
                }>
                {tran(`menu.${menuItem.meta.title}`)}
              </span>
            </el-tooltip>
          </el-menu-item>
        )
      } else {
        return
      }
    }
    function generateSubmenu(submenu) {
      return (
        <el-submenu
          index={submenu.path}
          key={submenu.path + submenu.meta.title}>
          <template slot="title">
            <div class="nav-name">
              <i class={submenu.meta?.icon}></i>
              <span>{tran(`menu.${submenu.meta.title}`)}</span>
            </div>
          </template>
          {!submenu.hidden &&
            submenu?.children.map((menuItem) =>
              menuItem?.children?.length > 0 && menuItem.isTop //为了避免3级菜单生成，加了menuItem.isTop
                ? generateSubmenu(menuItem)
                : generateMenuItem(menuItem)
            )}
        </el-submenu>
      )
    }

    const fixLanguageStyle = async () => {
      for (const [key, value] of Object.entries(
        languageStyleMap[getStorage('lang')] || {}
      )) {
        if (getStorage('lang') !== 'zh') {
          await import('./enStyle.scss')
          document
            .getElementsByTagName('body')[0]
            .style.setProperty(key, value as string)
        }
      }
    }

    const initFunc = async () => {
      //如果是url上带code，表示刚登录，调用一次cem自己的登录接口
      let code = getParamsValue('code')
      if (code) {
        await userLogintRun()
        dispatch('app/getAccountAuthority') //获取  用户角色  权限
      } else {
        dispatch('app/getAccountAuthority') //获取  用户角色  权限
      }
      dispatch('app/getTemplateDynamicInfo') //获取动态参数信息
      commit('app/commonMutations', { announcementOnlyShow: true })
      commit('app/commonMutations', { announcementVisible: false })
      commit('app/commonMutations', { announcementqeeVisible: false })
      await getUserInfoFn()
      const users = userInfoData?.data?.data || {}
      sessionStorage.setItem('user', users?.user || '')
      sessionStorage.setItem('userRoleName', users?.roleName || [])

      const reg = /（(.+?)）/
      const user = reg.exec(window?.sessionStorage.getItem('user') || '')
      dispatch('app/getAnnouncementLastOne', { userName: user?.[1] }) //最新公告
      //神策埋点
      if (users?.user) {
        sensors.login(users?.user)
        sensors.setProfile({
          cem_user: users?.user,
          cem_department:
            users?.userMessage?.directDepartNamePath || '接口未返回'
        })
      }

      afterRouteChange()
    }

    getMenuData()
    const toRouterClick = (path) => {
      router.push({
        path
      })
      getSideMenuData(path, true)
    }

    const dropCommandClick = (item) => {
      if (item == 1) {
        toRouterClick('/personalCenter')
      } else {
        userLogout({})
          .then(() => {})
          .finally(() => {
            if (import.meta.env.MODE === 'development') {
              window.location.href = `${instance?.proxy?.$env?.logoutUrl}?service=https://cem-test.wanyol.com/v2/front/` //本地使用测试环境
            } else {
              window.location.href = `${instance?.proxy?.$env?.logoutUrl}?service=${window.location.href}`
            }
          })
      }
    }

    const switchTranslateLanguage = async () => {
      if (language.value === 'chinese') {
        language.value = 'english'
        i18n.locale = 'en'
        setStorage('lang', 'en')
        languageBool.value = false
      } else {
        language.value = 'chinese'
        i18n.locale = 'zh'
        setStorage('lang', 'zh')
        languageBool.value = false
      }
      window.location.reload()
      // fixLanguageStyle()
    }
    window.localStorage.removeItem('isLinking') //清除保留的审核详情
    onMounted(() => {
      initFunc()
      const query = context.root?.$route?.query
      if (query.language) {
        language.value = query.language === 'en' ? 'english' : 'chinese'
        i18n.locale = query.language
        setStorage('lang', query.language)
        history.pushState({}, '', funcUrlDel('language'))
      } else {
        language.value = getStorage('lang') === 'en' ? 'english' : 'chinese'
      }
      const urlVal = window.location.href.slice(0, 20)
      if (urlVal.includes('-in')) {
        siteList.now = tran('personalCenter.IndianSite')
      } else if (urlVal.includes('-sin')) {
        siteList.now = tran('personalCenter.SingaporeSite')
      } else {
        siteList.now = tran('personalCenter.ChineseSite')
      }
      document.title = tran('common.webTitle')
      fixLanguageStyle()
    })

    const siteList = reactive({
      now: ''
    })
    const handleCommand = (value) => {
      if (value == 1) {
        window.location.href = `${window.env?.ChineseSite}?language=${i18n.locale}`
      } else if (value == 2) {
        window.location.href = `${window.env?.IndianSite}?language=${i18n.locale}`
      } else if (value == 3) {
        window.location.href = `${window.env?.SingaporeSite}?language=${i18n.locale}`
      }
    }

    const jumpToClick = async () => {
      await userLogout({})
      window.location.href = safety.redirectUrl
    }

    const envName = computed(() => {
      const hostName = window.location.hostname
      if (hostName === 'cem-test.wanyol.com') {
        return 'SIT'
      } else if (hostName === 'cem-uat.oppoit.com') {
        return 'UAT'
      } else {
        return ''
      }
    })

    return () => {
      return (
        languageBool.value &&
        safety.isComplete && (
          <div style="height: 100%">
            <div class="layout-wrapper">
              <div class="layout-header">
                <a
                  class="sidebar-logo-title-container"
                  href={`${window.location.origin}/v2/front/`}>
                  <div class="sidebar-logo-container" />
                  <div class="sidebar-title-container" />
                  {envName.value && <div class="env-diff">{envName.value}</div>}
                </a>
                <div class="navbar">
                  <div class="navbar-wrapper">
                    <div>{/* 顶部导航栏 */}</div>
                  </div>
                  <div class="right-menu">
                    {(!safety.isIndia || safety.isManage === '1') && (
                      <el-dropdown
                        onCommand={(command) => handleCommand(command)}
                        class="change-site"
                        size="small">
                        <el-link
                          suffix-icon="el-icon-arrow-down"
                          underline={false}>
                          {siteList.now}
                        </el-link>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="1">
                            {tran('personalCenter.ChineseSite')}
                          </el-dropdown-item>
                          {safety.isManage === '1' && (
                            <el-dropdown-item command="2">
                              {tran('personalCenter.IndianSite')}
                            </el-dropdown-item>
                          )}
                          <el-dropdown-item command="3">
                            {tran('personalCenter.SingaporeSite')}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    )}
                    <div
                      class="sys_feedback"
                      onClick={() => {
                        getUrlSetup({}).then((res) => {
                          if (res.code === 200) {
                            window.open(res.data)
                          }
                        })
                      }}>
                      <i class="iconfont icon-task1"></i>
                      {tran('index.system feedback')}
                    </div>

                    <div class="tools" title={tran('common.userManual')}>
                      <i
                        onClick={() => {
                          window.open(
                            'https://odocs.myoas.com/docs/wV3VVl24DJSmrr3y'
                          )
                        }}
                        class="el-icon-tickets"></i>
                    </div>
                    <div class="tools" title={tran('common.languageSwitching')}>
                      <div
                        class={`translate_icon ${
                          language.value === 'chinese'
                            ? 'translate_icon_english'
                            : 'translate_icon_chinese'
                        }`}
                        onClick={() => {
                          switchTranslateLanguage()
                        }}></div>
                    </div>
                    <div class="tools" title={tran('setting.ann')}>
                      <i
                        onClick={() => {
                          router.push({
                            path: '/setting/announcementManagement'
                          })
                        }}
                        class="el-icon-notification"></i>
                    </div>
                    <el-dropdown
                      style={{ 'margin-left': '20px' }}
                      onCommand={(item) => dropCommandClick(item)}>
                      <div
                        class="persional"
                        title={tran('menu.Personal center')}>
                        <el-avatar size="small" src={circleUrl}></el-avatar>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">
                          {tran('menu.Personal center')}
                        </el-dropdown-item>
                        <el-dropdown-item command="2">
                          {tran('personalCenter.logout')}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              {safety.isLoginError && safety.isManage !== '1' && (
                <div class="layout-container">
                  <div class="login-error-container">
                    <img src={noData}></img>
                    <div class="tips">
                      <p class="word">{safety.loginErrorTips}...</p>
                      <a href={safety.redirectUrl}>{tran('common.nowLogin')}</a>
                    </div>
                  </div>
                </div>
              )}
              {(!safety.isLoginError || safety.isManage === '1') && (
                <div class="layout-container">
                  <div
                    class="layout-sider"
                    style={{
                      width: isCollapse.value
                        ? '64px'
                        : i18n.locale === 'en'
                        ? '274px'
                        : '224px'
                    }}>
                    <div class="layout-sider-menu">
                      <el-menu
                        router
                        default-active={app.activeSiderMenuIndex}
                        class="el-menu-vertical-demo"
                        theme="dark"
                        unique-opened={true}
                        text-color="#fff"
                        collapse={isCollapse.value}
                        onSelect={handleSideMenuSelect}>
                        {menuData.map((menu) => {
                          return menu?.children?.length > 0 &&
                            menu.path !== '/personalCenter'
                            ? generateSubmenu(menu)
                            : generateMenuItem(menu)
                        })}
                      </el-menu>
                      <div
                        class="layout-left-collapsed"
                        style={{
                          width: isCollapse.value
                            ? '64px'
                            : i18n.locale === 'en'
                            ? '274px'
                            : '224px'
                        }}
                        onClick={handlerToggleSideBar}>
                        <i
                          class={`el-icon-menu-${
                            isCollapse.value ? 'un' : ''
                          }fold`}></i>
                        <span>
                          {isCollapse.value ? '' : tran('index.Fold the menu')}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="main-container">
                    <div class="layout-content-wrapper">
                      <AnnouncementMarguee />
                      <TagsView homePath="/content/surveyManagement/surveyList"></TagsView>
                      <div class="layout-content">
                        <div
                          class={
                            ['/v2/front/personalCenter/personalInfo'].includes(
                              window.location.pathname
                            )
                              ? 'bread-crumb-div-thin'
                              : 'bread-crumb-div'
                          }>
                          <BreadCrumb></BreadCrumb>
                        </div>
                        <div
                          v-loading={app.loading}
                          element-loading-text={tran('common.loading')}
                          element-loading-spinner="el-icon-loading"
                          element-loading-background="rgba(0, 13, 31, 0.25)"
                          class={[
                            'layout-content-box',
                            showBgColor.value && 'layout-content-box-bg'
                          ]}>
                          <DeleteTips
                            deleteTipsData={errorTips.errorTips}></DeleteTips>
                          <router-view />
                        </div>
                      </div>
                      {showBuutonPack.value && (
                        <PortalTarget name="buttom_button" />
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      )
    }
  }
})

export default Layout
